import {
    ANALYTICS_COLOR_1,
    ANALYTICS_COLOR_2,
    ANALYTICS_COLOR_3,
    ANALYTICS_COLOR_4,
    ANALYTICS_COLOR_INSTAGRAM,
    ANALYTICS_COLOR_POSTS,
    INSTAGRAM
} from '../../../config/constants';
import {
    METRIC_INSTAGRAM_COMMENTS_COUNT,
    METRIC_INSTAGRAM_CUMULATED_SHARES,
    METRIC_INSTAGRAM_ENGAGEMENT,
    METRIC_INSTAGRAM_FOLLOWER_COUNT,
    METRIC_INSTAGRAM_LIKE_COUNT,
    METRIC_INSTAGRAM_PROFILE_VIEWS,
    METRIC_INSTAGRAM_REACH,
    METRIC_INSTAGRAM_WEBSITE_CLICKS
} from '../../../config/metrics';
import * as icons from '../../../config/icons';
import {
    DEMO_DATA_INSTAGRAM_ENGAGEMENT_COMMENTS,
    DEMO_DATA_INSTAGRAM_ENGAGEMENT_LIKES,
    DEMO_DATA_INSTAGRAM_ENGAGEMENT_SHARES,
    DEMO_DATA_INSTAGRAM_GROWTH_FOLLOWERS,
    DEMO_DATA_INSTAGRAM_GROWTH_IMPRESSIONS,
    DEMO_DATA_INSTAGRAM_GROWTH_PROFILE_VIEWS
} from '../../../utils/demoDataUtils/demoDataArrays';
import {getStaticDataPoints} from '../../../utils/demoDataUtils/demoDataFunctions';
import {displayFunctions} from '../../../utils/chartsUtils';

const filters = {
    filters: []
};

export const growthConfig: any = {
    shouldBeCached: false,
    ...filters,
    // bar_plot_config: {
    //     title: 'Posts',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_YELLOW,
    //     type: 'bar'
    // },

    metrics: [
        {
            metrics: [207],
            title: 'impressions',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_1,
            type: 'line',
            formula: 'delta',
            display: 'sum',
            demo_data_config: {
                func: getStaticDataPoints,
                kwargs: {
                    data: DEMO_DATA_INSTAGRAM_GROWTH_IMPRESSIONS
                }
            }
        },
        {
            metrics: [METRIC_INSTAGRAM_FOLLOWER_COUNT],
            title: 'followers',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_2,
            type: 'line',
            platform: INSTAGRAM,
            demo_data_config: {
                func: getStaticDataPoints,
                kwargs: {
                    data: DEMO_DATA_INSTAGRAM_GROWTH_FOLLOWERS
                }
            }
        },
        {
            metrics: [METRIC_INSTAGRAM_PROFILE_VIEWS],
            title: 'profile_views',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_3,
            type: 'line',
            platform: INSTAGRAM,
            formula: 'delta',
            display: 'sum',
            demo_data_config: {
                func: getStaticDataPoints,
                kwargs: {
                    data: DEMO_DATA_INSTAGRAM_GROWTH_PROFILE_VIEWS
                }
            }
        }
        // {
        //     metrics: [METRIC_INSTAGRAM_REACH],
        //     title: 'reach',
        //     iconCssClass: 'fas fab-facebook',
        //     hexColor: ANALYTICS_COLOR_PINK,
        //     type: 'line'
        // },
    ]
};

export const accountConfig: any = {
    shouldBeCached: false,
    ...filters,
    // bar_plot_config: {
    //     title: 'Posts',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_YELLOW,
    //     type: 'bar'
    // },

    metrics: [
        // {
        //     metrics: [METRIC_INSTAGRAM_REACH],
        //     title: 'reaches',
        //     iconCssClass: 'optional value',
        //     hexColor: ANALYTICS_COLOR_GREEN,
        //     type: 'line'
        // },
        {
            metrics: [METRIC_INSTAGRAM_PROFILE_VIEWS],
            title: 'profile_view',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_4,
            type: 'line',
            platform: INSTAGRAM
        },
        {
            metrics: [METRIC_INSTAGRAM_WEBSITE_CLICKS],
            title: 'website_clicks',
            iconCssClass: 'optional value',
            hexColor: ANALYTICS_COLOR_3,
            type: 'line',
            platform: INSTAGRAM
        }
    ]
};

export const followersDevelopmentConfig = {
    shouldBeCached: false,
    ...filters,
    no_data_available: 'no_data_available',
    metrics: [
        {
            metrics: [METRIC_INSTAGRAM_FOLLOWER_COUNT],
            title: 'Fans',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_2,
            type: 'bar',
            formula: 'delta',
            display: 'max',
            platform: INSTAGRAM
        }
    ]
};

const organicsummary = {
    shouldBeCached: false,
    ...filters,
    // bar_plot_config: {
    //     title: 'Posts',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_YELLOW,
    //     type: 'bar'
    // },

    metrics: [
        {
            metrics: [METRIC_INSTAGRAM_ENGAGEMENT],
            title: 'engagement',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_1,
            type: 'line',
            formula: 'delta',
            display: 'sum'
        },
        {
            metrics: [METRIC_INSTAGRAM_LIKE_COUNT],
            title: 'reactions',
            iconCssClass: icons.PLATFORM_ICONS[INSTAGRAM],
            hexColor: ANALYTICS_COLOR_INSTAGRAM,
            type: 'line',
            formula: 'delta',
            display: 'sum'
            // platform: INSTAGRAM
        },
        {
            metrics: [METRIC_INSTAGRAM_REACH],
            title: 'reach',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_3,
            type: 'line',
            formula: 'delta',
            display: 'sum',
            platform: INSTAGRAM
        }
    ]
};

const organicInteractions = {
    shouldBeCached: false,
    ...filters,
    // bar_plot_config: {
    //     title: 'posts',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_YELLOW,
    //     type: 'bar'
    // },

    metrics: [
        {
            metrics: [METRIC_INSTAGRAM_LIKE_COUNT],
            title: 'likes',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_3,
            type: 'line',
            formula: 'delta',
            display: 'sum',
            demo_data_config: {
                func: getStaticDataPoints,
                kwargs: {
                    data: DEMO_DATA_INSTAGRAM_ENGAGEMENT_LIKES
                }
            }
        },
        {
            metrics: [METRIC_INSTAGRAM_COMMENTS_COUNT],
            title: 'comments',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_1,
            type: 'line',
            formula: 'delta',
            display: 'sum',
            demo_data_config: {
                func: getStaticDataPoints,
                kwargs: {
                    data: DEMO_DATA_INSTAGRAM_ENGAGEMENT_COMMENTS
                }
            }
        },
        {
            metrics: [METRIC_INSTAGRAM_CUMULATED_SHARES],
            title: 'shares',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_2,
            type: 'line',
            formula: 'delta',
            display: 'sum',
            demo_data_config: {
                func: getStaticDataPoints,
                kwargs: {
                    data: DEMO_DATA_INSTAGRAM_ENGAGEMENT_SHARES
                }
            }
        }
    ]
};

export const postsConfig = {
    // overview: organicsummary,
    engagement: organicInteractions
};

const reelConfig = {
    shouldBeCached: false,
    ...filters,
    // bar_plot_config: {
    //     title: 'posts',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_YELLOW,
    //     type: 'bar'
    // },

    metrics: [
        {
            metrics: [METRIC_INSTAGRAM_LIKE_COUNT],
            title: 'likes',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_3,
            type: 'line',
            formula: 'delta',
            display: 'max'
        },
        {
            metrics: [METRIC_INSTAGRAM_COMMENTS_COUNT],
            title: 'comments',
            iconCssClass: 'fas fab-facebook',
            hexColor: ANALYTICS_COLOR_1,
            type: 'line',
            formula: 'delta',
            display: 'max'
        }
    ]
};
// -----------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------------

export const impressions = {
    addAdditionalPlots: true,
    impressions: {
        title: 'mixedChart.impressions',
        hexColor: ANALYTICS_COLOR_1,
        type: 'line',

        display: displayFunctions.sum
    }
};
export const likes = {
    addAdditionalPlots: true,
    likes: {
        title: 'mixedChart.likes',
        hexColor: ANALYTICS_COLOR_1,
        type: 'line',

        display: displayFunctions.sum
    }
};
export const profileAnalytics = {
    addAdditionalPlots: true,
    title: 'profile_engagement',
    profile_views: {
        title: 'mixedChart.profile_views',
        hexColor: ANALYTICS_COLOR_1,
        type: 'line',

        display: displayFunctions.sum
    },

    website_clicks: {
        title: 'mixedChart.website_clicks',
        hexColor: ANALYTICS_COLOR_2,
        type: 'line',

        display: displayFunctions.sum
    },

    profile_links_taps: {
        title: 'mixedChart.profile_links_taps',
        hexColor: ANALYTICS_COLOR_3,
        type: 'line',

        display: displayFunctions.sum
    }
};
export const reach = {
    addAdditionalPlots: true,

    reach: {
        title: 'mixedChart.reach',
        hexColor: ANALYTICS_COLOR_1,
        type: 'line',

        display: displayFunctions.sum
    }
};
export const totalIntercations = {
    addAdditionalPlots: true,

    total_interactions: {
        title: 'mixedChart.total_interactions',
        hexColor: ANALYTICS_COLOR_1,
        type: 'line',

        display: displayFunctions.sum
    }
};
export const profileFollowers = {
    addAdditionalPlots: true,

    profile_followers: {
        title: 'mixedChart.profile_followers',
        hexColor: ANALYTICS_COLOR_1,
        type: 'line',
        infoMessage: 'instagram_profile_followers_info',

        display: displayFunctions.lastValue
    }
};

export const newConfigsMap: any = {
    impressions,
    likes,
    reach,
    total_interactions: totalIntercations,
    profile_followers: profileFollowers,
    profile_analytics: profileAnalytics,
    posts_per_day: {
        normalizeValues: true,
        title: 'mixedChart.posts_per_day',
        hexColor: ANALYTICS_COLOR_POSTS,
        type: 'bar',
        display: displayFunctions.sum,
        additionalPlot: true
    },
    posts_per_day_plot: {
        posts_per_day_plot: {
          title: 'mixedChart.posts_per_day_plot',
          hexColor: ANALYTICS_COLOR_POSTS,
        type: 'bar',
        display: displayFunctions.sum,
        additionalPlot: true
        }
    }
};
